import React, { useState, useEffect, useRef } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import FeedContentsTable from './tables/FeedContentsTable';
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom';
import endpoints, { getBackendUrl } from '../../endpoints';
import axios from 'axios';
import withAlert from '../../hoc/withAlerts'
import Loading from '../pages/parts/Loading'
import Stack from '@mui/material/Stack';
import Confirmation from './modals/Confirmation';
import SelectPromptModal from './modals/SelectPromptModal';
import AddTagForm from './forms/AddTagForm';
import Stepper from '@mui/material/Stepper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/DeleteRounded';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Alert from '@mui/material/Alert';
import WriteCoverForm from './forms/WriteCoverForm';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMoreRounded';
import { setHeader } from '../../redux/headerSlice'
import {setFormValueById} from '../../utils/Utils'


function CoverLetters(props) {
    let params = useParams();
    const feedContentId = params.id;

    const [list, setList] = useState([])
    const [lastVersion, setLastVersion] = useState([])
    const [loading, setLoading] = useState(false)
    const [activeStep, setActiveStep] = React.useState(0);
    const [selectedVersion, setSelectedVersion] = React.useState('');
    const [deleteItem, setDeleteItem] = useState(null)
    const [selectedPrompt, setSelectedPrompt] = useState(null)

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const token = useSelector((state) => state.auth.token)
    const dispatch = useDispatch()
    
    const queryParams = new URLSearchParams(window.location.search)
    const owner = queryParams.get('owner')
    let ownerBreadcrumb = {}
    if (owner && owner.split('|')[0]  == 'feeds') {
        ownerBreadcrumb = {
            title: 'Feed Contents',
            link: '/feeds/contents/' + owner.split('|')[1],
        }
    } else {
        ownerBreadcrumb = {
            title: 'Reports',
            link: '/reports',
        }
    }

    useEffect(() => {
        getList()
        dispatch(setHeader({
            title: 'Cover Letters'
        }))
    }, []);


    const getList = async () => {
        let uri = getBackendUrl(endpoints.coverletters, token)
        uri = uri.replace('{feedContentId}', feedContentId)

        try {
            setList([])

            let res = await axios.get(uri)
            setList(res.data.versions)
            setActiveStep(res.data.versions.length - 1)
            if (res.data.versions.length) {
                setSelectedVersion(res.data.versions[res.data.versions.length - 1].version)
                setLastVersion(res.data.versions[res.data.versions.length - 1].version)
            } else {
                setSelectedVersion(1)
                setLastVersion(1)
            }
        } catch (e) {
            showAlertError('Unknown Error - get covers list')
        }
    }
    
    const writeCoverStart = async () => {
        setLoading(true)
    }
    
    const writeCoverFinish = async (ok, message) => {
        if (ok) {
            await getList()
            showAlertSuccess('Cover added successfully!')
        } else
        if (message) {
            showAlertError(message)
        }
        setLoading(false)
    }
    
    const deleteHandle = async (result) => {
        if (result) {
            let uri = getBackendUrl(endpoints.coverletters_delete, token)
            uri = uri.replace('{feedContentId}', feedContentId)
            uri = uri.replace('{version}', deleteItem.id)

            try {
                setLoading(true)
                await axios.delete(uri)
                getList()
                showAlertSuccess('Cover version deleted successfully!')
                setLoading(false)
            } catch (e) {
                setLoading(false)
                showAlertError('Unknown Error - delete cover')
            }
        }
        
        setDeleteItem(null)
    }

    const showAlertError = (message) => {
        props.showAlert(message, 'error')
    }

    const showAlertSuccess = (message) => {
        props.showAlert(message, 'success')
    }

    return (
        <Paper sx={{ maxWidth: 1200, margin: 'auto', overflow: 'hidden', marginTop: '20px' }}>
            <Box sx={{ padding: '20px' }}>
                <Stepper activeStep={activeStep} orientation="vertical">
                    {list.length == 0 ? 
                    <Alert severity="warning" sx={{ marginBottom: '10px' }}>There is no cover yet</Alert>
                    : null }
                    {list.map((version, index) => (
                        <Step key={index}>
                            <StepLabel
                                className='version-stepper'
                                onClick={() => setActiveStep(index)}
                                optional={
                                    index === list.length - 1 ? (
                                        <Typography variant="caption">Last step</Typography>
                                    ) : null
                                }
                            >
                                Version {version.version}
                            </StepLabel>
                            <StepContent>
                                <Box>
                                    {version.items.map((item, versionIndex) => (
                                        <Accordion key={versionIndex} defaultExpanded={versionIndex === version.items.length - 1}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel2a-content"
                                                id="panel2a-header"
                                            >
                                                <Alert severity="warning" sx={{ marginBottom: '10px' }}>
                                                    <b>Promt: </b>{item.prompt}
                                                    <IconButton 
                                                        color="error" 
                                                        component="label" 
                                                        onClick={(e) => { setDeleteItem(item); e.stopPropagation() }}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Alert>
                                            </AccordionSummary>
                                          <AccordionDetails >
                                            <Alert severity="info" sx={{ marginBottom: '30px', whiteSpace: 'pre-line' }}>
                                              <b>GPT answer: </b><br />
                                              {item.content}
                                            </Alert>
                                          </AccordionDetails>
                                        </Accordion>
                                    ))}
                                </Box>

                            <Box sx={{ mb: 2 }}>
                              <div>
                                <Button
                                  disabled={index === 0}
                                  onClick={handleBack}
                                  sx={{ mt: 1, mr: 1 }}
                                  variant='outlined'
                                >
                                  Prev. version
                                </Button>
                                {index < list.length - 1 ?
                                    (
                                      <Button
                                        variant="outlined"
                                        onClick={handleNext}
                                        sx={{ mt: 1, mr: 1 }}
                                      >
                                        Next version
                                      </Button>
                                    )
                                    : null}
                              </div>
                            </Box>
                          </StepContent>
                        </Step>
                    ))}
                </Stepper>
            </Box>

            {loading ? <Loading /> :
            <Grid container spacing={2} sx={{ padding: '20px' }}>
                <Grid item xs={12}>
                    <Stack direction="row">
                        <FormControl size="small" variant="standard" sx={{ minWidth: '200px' }}>
                            <InputLabel id="demo-simple-select-label">Version</InputLabel>
                            <Select
                                fullWidth
                                labelId="demo-simple-select-label"
                                label="Select version"
                                value={selectedVersion}
                                onChange={(e) => setSelectedVersion(e.target.value)}
                                variant="standard"
                            >
                                {list.map((version, key) => (
                                    <MenuItem key={key} value={version.version}>Version {version.version}</MenuItem>
                                ))}
                                <MenuItem key={lastVersion + 1} value={lastVersion + 1}>New version</MenuItem>
                            </Select>
                        </FormControl>
                        <Stack sx={{ flexGrow:1 }}></Stack>
                        <FormControl 
                            size="small" 
                            variant="standard"
                            sx={{ paddingTop:1.4 }}
                        >
                            <Button variant="contained" color="primary" onClick={() => {setSelectedPrompt({})}}>
                                Prompts
                            </Button>
                        </FormControl>
                    </Stack>
                </Grid>
                <Grid item xs={12}>
                    <WriteCoverForm
                        feedContentId={feedContentId}
                        selectedVersion={selectedVersion}
                        writeCoverStart={writeCoverStart}
                        writeCoverFinish={writeCoverFinish}
                    />
                </Grid>
            </Grid>
            }

            <SelectPromptModal 
                selectedPrompt={selectedPrompt}
                onClose={() => {setSelectedPrompt(null)}}
                onSelect={(item) => {
                    setFormValueById('writeCoverFormValue', item.content)
                    setSelectedPrompt(null)
                }}
            />
            <Confirmation data={deleteItem} onResponse={deleteHandle} />
        </Paper>
    )
}

export default withAlert(CoverLetters)